<template>
  <div class="integral" ref="container">
    <div class="information" v-for="(item, index) in list" :key="index">
      <div class="residue">
        {{ item.status }}
      </div>
      <!-- <div class="sy">
        {{ item.sy_nlz }}
      </div> -->
      <div class="data1">
        <div class="num">
          <div class="hold">生态值</div>
          {{ item.nlz }}
        </div>
        <div class="num" style="margin-left: 0.4rem">
          <div class="hold">剩余生态值</div>
          {{ item.sy_nlz }}
        </div>
      </div>
      <div class="data2">
        <div class="num">
          <div class="hold">爱心值</div>
          {{ item.gxz }}
        </div>
        <div class="num" style="margin-left: 0.4rem">
          <div class="hold">剩余爱心值</div>
          {{ item.sy_gxz }}
        </div>
      </div>
      <div class="data2">
        <div class="num">
          <div class="hold">时间</div>
          {{ item.add_time }}
        </div>
        <div class="num" style="margin-left: 0.4rem">
          <div class="hold">单号</div>
          {{ item.order_id }}
        </div>
      </div>
      <div
        class="shift"
        @click="goPagey('/user/exchange4?id=' + item.id)"
        v-if="item.from == 0 && item.sy_nlz > 0"
      >
        加速燃烧生态值
      </div>
    </div>
    <div class="nolist" v-if="list.length == 0">暂无数据~</div>
  </div>
</template>

<script>
import { nlz } from "../../api/user.js";
export default {
  name: "integral",
  data() {
    return {
      loading: false,
      loadend: false,
      list: [],
      user: {},
      limit: 15,
      page: 1
    };
  },
  mounted() {
    this.getList();
    // this.getTzInfo();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getList();
    });
  },
  methods: {
    goPagey(url) {
      this.$router.push({ path: url });
    },
    // getTzInfo() {
    //   getTzInfo().then(res => {
    //     this.user = res.data;
    //   });
    // },
    getList() {
      if (this.loading || this.loadend) return;
      this.loading = true;
      let data = {
        page: this.page,
        limit: this.limit
      };
      nlz(data).then(res => {
        this.list = this.page == 1 ? res.data : this.list.concat(res.data);
        this.loading = false;
        this.page++;
        this.loadend = this.limit > res.data.length;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.integral {
  padding-top: 0.2rem;
  // background-color: #313040;
  .title-module {
    width: 100%;
    line-height: 1rpx;
    text-align: center;
    background-color: #0e98fd;
    color: #fff;
  }

  .list {
    .item {
      padding: 0.2rem 0.3rem;
      background-color: #fff;
      // height: 124rem;
      border-bottom: 0.01rem solid #eee;

      .left {
        .title {
          color: #282828;
          font-size: 0.28rem;
          margin-bottom: 0.06rem;
          white-space: pre-line;
        }

        .time {
          font-size: 0.24rem;
          color: #999;
          margin-top: 0.1rem;
        }
      }

      .right {
        font-size: 0.36rem;
        font-family: guildfordprobook\5;
        color: #ff2739;
        flex-shrink: 0;

        &.on {
          color: #16ac57;
        }
      }
    }
  }
}

.information {
  position: relative;
  min-height: 3.6rem;
  width: 6.7rem;
  margin: 0 0.4rem 0.2rem;
  background-color: #0e98fd;
  border-radius: 0.2rem;
  padding: 0.2rem 0.3rem;
  color: #fff;
  .residue {
    position: absolute;
    right: -0.1rem;
    top: -0.1rem;
    width: 0.8rem;
    height: 0.8rem;
    line-height: 0.8rem;
    text-align: center;
    font-weight: bold;
    font-size: 0.3rem;
    background-color: #97d23b;
    color: #fff;
    border-radius: 0.4rem;
  }
  .sy {
    font-size: 0.4rem;
    font-weight: bold;
    // margin-bottom: 20rem;
  }
  .data2,
  .data1 {
    font-size: 0.28rem;
    margin-top: 0.2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .num {
      width: 50%;
    }
    .hold {
      margin-bottom: 0.06rem;
    }
  }
}
.shift {
  margin-top: 0.2rem;
  text-align: center;
  height: 0.6rem;
  width: 3rem;
  margin-left: 1.55rem;
  background-color: #fff;
  color: #0e98fd;
  border-radius: 0.3rem;
  line-height: 0.6rem;
  font-weight: bold;
}
</style>
